module.exports = __webpack_public_path__ + "static/media/details-screen.fd37fa32.png";